/* Independent product chapters: safe to reorder and reload in the theme editor. */
if (!customElements.get('il-product-section')) {
  customElements.define('il-product-section', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('click', event => {
        const zoom = event.target.closest('[data-zoom]');
        const dialog = this.querySelector('dialog');
        if (zoom && dialog) {
          this.lastImageTrigger = zoom;
          dialog.querySelector('img').src = zoom.dataset.zoom;
          dialog.querySelector('[data-original-image]').href = zoom.dataset.zoom;
          dialog.showModal();
        }
        if (dialog && (event.target.closest('[data-close-dialog]') || event.target === dialog)) dialog.close();
        const arrow = event.target.closest('[data-slide]');
        const track = this.querySelector('.il-pdp__ingredient-track');
        if (arrow && track) track.scrollBy({left:Number(arrow.dataset.slide) * track.clientWidth * .85, behavior:this.motion.matches ? 'instant':'smooth'});
      }, options);
      this.querySelector('dialog')?.addEventListener('close', () => this.lastImageTrigger?.focus(), options);
      this.videoObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting && !this.motion.matches) entry.target.play().catch(() => {});
          else entry.target.pause();
        }
      }, {threshold:.15});
      const videos = this.querySelectorAll('video:not(.il-pdp__experience-video):not(.il-capsule__video)');
      videos.forEach(video => this.videoObserver.observe(video));
      this.motion.addEventListener('change', () => videos.forEach(video => {
        if (this.motion.matches) video.pause();
        else {this.videoObserver.unobserve(video);this.videoObserver.observe(video);}
      }), options);
      this.bundleForms = [...this.querySelectorAll('[data-bundle-form]')];
      if (!this.bundleForms.length) return;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.bundleVariants = JSON.parse(this.querySelector('[data-bundle-variants]')?.textContent || '[]');
      this.bundleButtons = [...this.querySelectorAll('[data-bundle-buy]')];
      this.buyButtons = [];
      this.message = this.bundleForms[0].querySelector('[data-bundle-message]');
      const hero = [...document.querySelectorAll('il-product-page')].find(node => node.dataset.productId === this.dataset.productId);
      const selectedId = hero?.querySelector('.il-pdp__form [name="id"]')?.value || this.bundleForms[0].querySelector('[data-bundle-main-id]').value;
      this.selectVariant(selectedId);
      document.addEventListener('variant:changed', event => {
        const source = event.target.closest?.('il-product-page');
        if (source?.dataset.productId === this.dataset.productId) this.selectVariant(event.detail?.variant?.id);
      }, options);
      this.bundleForms.forEach(form => {
        form.addEventListener('submit', event => this.addToCart(event, form), options);
        form.querySelector('[data-bundle-option]').addEventListener('change', () => this.updateBundle(), options);
      });
    }
    selectVariant(id) {
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      this.variant = variant;
      this.updateBundle();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.videoObserver?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
    updateBundle() {
      const v = this.variant;
      if (!v || !this.bundleForms.length) return;
      this.bundleVariant = this.bundleVariants.find(extra => String(extra.id) === this.bundleForms[0].querySelector('[data-bundle-option]').value);
      const extra = this.bundleVariant;
      if (!extra) return;
      this.bundleForms.forEach(form => {
        form.querySelector('[data-bundle-main-id]').value = v.id;
        form.querySelector('[data-bundle-main-quantity]').value = v.min;
        form.querySelector('[data-bundle-extra-quantity]').value = extra.quantity;
        form.querySelector('[data-bundle-main-count]').textContent = v.min;
        form.querySelector('[data-bundle-extra-count]').textContent = extra.quantity;
        form.querySelector('[data-bundle-main-price]').textContent = v.price;
        form.querySelector('[data-bundle-extra-price]').textContent = extra.price;
        form.querySelector('[data-bundle-main-option]').textContent = v.title === 'Default Title' ? '' : v.title;
        form.querySelector('[data-bundle-total]').textContent = extra.totals[v.id];
        const button = form.querySelector('[data-bundle-buy]');
        button.disabled = !v.available || !extra.available || !!this.busy;
        button.querySelector('[data-buy-label]').textContent = v.available && extra.available ? (button.dataset?.bundleLabel || 'Add both to cart') : 'Bundle unavailable';
      });
    }
    async addToCart(event, form) {
      event.preventDefault();
      if (this.busy || !this.variant?.available || !this.bundleVariant?.available || !form.reportValidity()) return;
      this.busy = true;
      const message = form.querySelector('[data-bundle-message]');
      message.textContent = '';
      this.bundleButtons.forEach(button => {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.querySelector('[data-buy-label]').textContent = 'Adding…';
      });
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method:'POST', headers:{'X-Requested-With':'XMLHttpRequest', 'Content-Type':'application/json'}, signal:this.abort.signal,
          body:JSON.stringify({items:[{id:this.variant.id, quantity:this.variant.min}, {id:this.bundleVariant.id, quantity:this.bundleVariant.quantity}], sections:['mini-cart'], sections_url:location.pathname})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This bundle could not be added. Please check the selected options.');
        message.textContent = 'Both products added to your cart.';
        for (const item of result.items || [result]) form.dispatchEvent(new CustomEvent('variant:added', {bubbles:true, detail:{variant:item}}));
        if (result.sections?.['mini-cart']) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true, detail:{cart:result, openMiniCart:window.themeVariables?.settings?.cartType === 'drawer'}}));
        try {
          const cart = await (await fetch(`${root}cart.js`, {signal:this.abort.signal})).json();
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {bubbles:true, detail:{cart}}));
        } catch (error) { /* Already added; a count refresh failure must not invite a duplicate submission. */ }
        if (window.themeVariables?.settings?.cartType === 'page') location.assign(`${root}cart`);
      } catch (error) {
        if (error.name !== 'AbortError') message.textContent = error.message || 'Unable to add this bundle. Please try again.';
      } finally {
        this.busy = false;
        this.bundleButtons.forEach(button => button.removeAttribute('aria-busy'));
        if (this.isConnected) this.updateBundle();
      }
    }
  });
}
